// GTM utility functions
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export interface GTMConfig {
  gtmId: string;
  enableAnalytics?: boolean;
}

export const GTM_ID = 'GTM-MDD5C4';

export const initGTM = (gtmId: string = GTM_ID) => {
  if (!gtmId || typeof window === 'undefined') {
    console.warn('GTM ID not provided or running server-side');
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];

  // Add GTM script to head
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(gtmScript);

  // Initialize GTM
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
};

export const gtmEvent = (eventName: string, parameters: Record<string, any> = {}) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    console.warn('GTM not initialized or running server-side');
    return;
  }

  const eventData = {
    event: eventName,
    timestamp: new Date().toISOString(),
    ...parameters,
  };

  window.dataLayer.push(eventData);
  console.log('GTM Event:', eventData);
};

// Specific event functions for this application
export const gtmEvents = {
  funnelEntry: (data: { page: string; flow?: string; userId?: string }) => {
    gtmEvent('ds_funnel_entry', {
      event_category: 'funnel',
      event_label: 'entry',
      page: data.page,
      flow: data.flow,
      user_id: data.userId,
    });
  },

  previewPageView: (data: { metaSiteId?: string; flow?: string; userId?: string; storeName?: string }) => {
    gtmEvent('preview_page_view', {
      event_category: 'preview',
      event_label: 'page_view',
      meta_site_id: data.metaSiteId,
      flow: data.flow,
      user_id: data.userId,
      store_name: data.storeName,
    });
  },

  premiumUpgradeComplete: (data: { metaSiteId?: string; flow?: string; userId?: string }) => {
    gtmEvent('ds_funnel_premium', {
      event_category: 'funnel',
      event_label: 'premium_upgrade_complete',
      meta_site_id: data.metaSiteId,
      flow: data.flow,
      user_id: data.userId,
    });
  },

  checkoutClick: (data: { metaSiteId?: string; flow?: string; userId?: string; couponCode?: string }) => {
    gtmEvent('ds_funnel_checkout_click', {
      event_category: 'funnel',
      event_label: 'checkout_click',
      meta_site_id: data.metaSiteId,
      flow: data.flow,
      user_id: data.userId,
      coupon_code: data.couponCode,
    });
  },
};
